import { createAction } from 'redux-actions';
import { authFetch, authUpload } from '../AuthFetch';

export const changeGearModelValue = createAction('CHANGE_GEARMODEL_VALUE');

export const findGearModelList = (pagingData) => (
  (dispatch) => {
    let url = '/firefighter/gearModels?activePage=' + pagingData.activePage + '&itemPerPage=' + pagingData.itemPerPage;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_GEARMODEL_LIST',
        payload: json
      });
    });
  }
);

export const findAllModelNos = () => (
  (dispatch) => {
    let url = '/firefighter/gearModels/allModelNos';
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ALL_MODELNOS',
        payload: json
      });
    });
  }
);

export const addGearModel = (gearModel, pagingData) => (
  (dispatch) => {
    let url = '/firefighter/gearModels';
    authFetch('POST', url, JSON.stringify(gearModel), (json) => {
      dispatch({
        type: 'FORM_SUBMIT_GEARMODEL',
        payload: json
      });
      dispatch(findGearModelList(pagingData));
    });
  }
);

export const editGearModel = (gearModel, pagingData) => (
  (dispatch) => {
    let url = '/firefighter/gearModels/' + gearModel.get('modelNo');
    authFetch('PUT', url, JSON.stringify(gearModel), (json) => {
      dispatch({
        type: 'FORM_SUBMIT_GEARMODEL',
        payload: json
      });
      dispatch(findGearModelList(pagingData));
    });
  }
);

export const deleteGearModel = (deleteKey, pagingData) => (
  (dispatch) => {
    let url = '/firefighter/gearModels';
    authFetch('DELETE', url, JSON.stringify(deleteKey), (json) => {
      dispatch({
        type: 'DELETE_GEARMODEL',
        payload: json
      });
      dispatch(findGearModelList(pagingData));
    });
  }
);

export const findGearModel = (pk) => (
  (dispatch) => {
    let url = '/firefighter/gearModels/' + pk.model_no;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_GEARMODEL',
        payload: json
      });
    });
  }
);

export const changeGearModelActivePage = createAction('CHANGE_GEARMODEL_ACTIVE_PAGE');
export const openGearModelModal = createAction('OPEN_GEARMODEL_MODAL');
export const openGearModelUploadModal = createAction('OPEN_GEARMODEL_UPLOAD_MODAL');
export const closeGearModelModal = createAction('CLOSE_GEARMODEL_MODAL');

export const uploadModelTemplate = (modelNo, templateType, uploadFile, pagingData) => (
  (dispatch) => {
    if (modelNo) {
      let formData = new FormData();
      formData.append('uploadfile', uploadFile);
      let pk = { model_no: modelNo };

      dispatch({
        type: 'BEFORE_UPLOAD_MODEL_TEMPLATE'
      });

      let url = '/firefighter/gearModels/' + modelNo + '/type/' + templateType + '/uploadModelTemplate';
      authUpload('POST', url, formData, (json) => {
        dispatch({
          type: 'AFTER_UPLOAD_MODEL_TEMPLATE',
          payload: json
        });
        dispatch(findGearModelList(pagingData));
        dispatch(findGearModel(pk));
      });
    }
    else {
      console.log('modelNo is null');
    }
  }
);

export const updateModelType = (gearModel, pagingData) => (
  (dispatch) => {
    let url = '/firefighter/gearModels/' + gearModel.get('modelNo') + '/type';
    authFetch('PUT', url, JSON.stringify(gearModel), (json) => {
      dispatch({
        type: 'AFTER_UPLOAD_MODEL_TEMPLATE',
        payload: json
      });
      dispatch(findGearModelList(pagingData));
    });
  }
);

export const findModelNosBySizeType = (SizeType) => (
  (dispatch) => {
    let url = '/firefighter/gearModels/modelNos/' + SizeType;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_MODELNOS_BY_SIZETYPE',
        payload: json
      });
    });
  }
);

export const findAllModelSizeTypes = () => (
  (dispatch) => {
    let url = '/firefighter/gearModels/sizeTypes';
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ALL_MODEL_SIZETYPES',
        payload: json
      });
    });
  }
);


// WEBPACK FOOTER //
// ./src/actions/gearModelActions.js